import { useNavigate } from "react-router-dom"
import Header from "../../Components/Header"
import { PrimaryButton } from "../../Components/Elements/CustomButtons"
import { LeftArrowIcon } from "../../utils/iconFactory"
import { useTheme } from "../../utils/themeUtils"
import { classNames } from "../../utils/utils"

export function Error() {
  const navigate = useNavigate()
  const { themeString } = useTheme()

  return (
        <div className={classNames("flex flex-1 flex-col bg-backgroundLightGray h-screen w-full relative", themeString)}>
          <Header/>
          <div className="h-[95px] w-full" />

          <main className="flex flex-1 flex-col w-full justify-center items-center bg-backgroundWhite rounded-t-[16px]">
            <div className="flex gap-[67px] px-10">
              <img src="/robot1.png" alt="" className="max-h-[368px] max-w-[350px]" />
              <div className="flex flex-col gap-8 justify-center max-w-[732px] mx-auto">
                <h1 className="text-textMain text-style-h1 max-w-[67%]">A keresett oldal nem található.</h1>
                <p className="text-textSecondary text-style-body1">Elakadtál, esetleg problémát tapasztaltál? Írj egy üzenetet a kérdéseddel vagy a probléma leírásával az <span className="font-bold">aidaappapp@gmail.com</span> e-mail címre és igyekszünk minél hamarabb válaszolni!</p>
                <PrimaryButton
                  buttonInfo={{label: "Vissza a főoldalra", buttonIcon: LeftArrowIcon}} 
                  className="mt-4 max-w-[67%]" 
                  onClick={() => {navigate('/'); window.location.reload()}}
                />
              </div>
            </div>
          </main>
        </div>
    )
}